/*
 * Product Image ScrollTo Interaction
 */

custom.productScroll = (function () {
  const $thumbnails = $('.js-product-scroll');
  const $imagesContainer = $('.product-detail__images.vertical-scroll');
  const MARGIN_OFFSET = 24;

  // Accounting for the margin offset of 24px
  function getYoffset($element) {
    return (
      $element.position().top + $imagesContainer.scrollTop() + MARGIN_OFFSET
    );
  }

  function getTarget(targetId) {
    // Check if the element is a video or not
    if (targetId === 'video') {
      return $('.video-container');
    }

    // If it's not a video then return the element with the data-product-image-id attribute
    return $(`[data-product-image-id="${targetId}"]`);
  }

  function scrollToHandler(event) {
    // Get thumbnail ID from clicked thumbnail and find matching image/video
    const targetId = $(event.currentTarget).data('product-thumbnail-id');
    const $target = getTarget(targetId);

    if (!$target.length) return;

    const scrollPosition = getYoffset($target);
    $imagesContainer.animate({ scrollTop: scrollPosition }, 400);    
  }

  function isMobile() {
    return $(window).width() < 768;
  }

  function lastImageHandler() {
    //if the image container is taller than the last image set the bottom padding of the last image to match the height of the image container
    const lastImage = $imagesContainer.find('div.is-image').last();
    if (!isMobile()) {
      const lastImage = $imagesContainer.find('div.is-image').last();
      const isVideo = lastImage.hasClass('video-container');
      if (isVideo) {
        const video = lastImage.find('video');
        if ($imagesContainer.height() > video.height()) {
          lastImage.css(
            'margin-bottom',
            $imagesContainer.height() - video.height(),
          );
        }
      } else {
        if ($imagesContainer.height() > lastImage.height()) {
          lastImage.css(
            'padding-bottom',
            $imagesContainer.height() - lastImage.height(),
          );
        }
      }
    } else {
      lastImage.css('padding-bottom', 0);
    }
  }

  function init() {
    $(window).on('resize', lastImageHandler);
    lastImageHandler();

    $thumbnails.on('click', scrollToHandler);
  }

  return {
    init: init,
  };
})();

custom.productScroll.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/product-scroll.js